import { wrappedApiGet, wrappedApiPost } from 'utils/http';
import { PageResponse } from '@payer-admin-ui/api/src/utils/repository/PageResponse';
import { ClientNotificationResponse } from '@payer-admin-ui/api/src/notifications/models';

export type FetchNotificationsParams = {
  page: number;
  pageSize: number;
  channel?: string;
  sort?: string;
};

export const notificationAPI = {
  fetchPage: async ({
    page,
    pageSize,
    channel,
    sort,
  }: FetchNotificationsParams): Promise<PageResponse<ClientNotificationResponse>> => {
    return wrappedApiGet<PageResponse<ClientNotificationResponse>>('/notifications', {
      query: {
        offset: page * pageSize,
        pageSize,
        channel,
        sort,
      },
    }).withObjectResponse();
  },
  markSeen: async (id: string): Promise<void> => {
    return wrappedApiPost(`/notifications/${id}/seen`).withEmptyResponse();
  },
  markHandled: async (id: string): Promise<void> => {
    return wrappedApiPost(`/notifications/${id}/handled`).withEmptyResponse();
  },
};
